import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add User
function creatUser(params: any) {
    const baseUrl = `/users/createUser`;
    return api.createWithFile(`${baseUrl}`, params);
}
// update User
function updateUser(params: any) {
    const baseUrl = '/users/updateUser';
    return api.updatePutWithFile(`${baseUrl}`, params);
}

// get all Users
function getAllUser(params: any) {
    const baseUrl = '/users/getAllUser';
    return api.create(`${baseUrl}`, params);
}

// get User
function getUser(params: any) {
    const baseUrl = '/users/getUserDetail';
    return api.create(`${baseUrl}`, params);
}

// get User Basic Roles
function getUserBasicRoles(params: any) {
    const baseUrl = '/users/getConfigRoles';
    return api.create(`${baseUrl}`, params);
}

// get User Capture hits
function getUserHits(params: any) {
    const baseUrl = '/users/registerUserHit';
    return api.create(`${baseUrl}`, params);
}

export { creatUser, updateUser, getAllUser, getUser, getUserHits, getUserBasicRoles };
